/**
 * Convert markdown text to HTML for rendering in TipTap editors
 */
export const markdownToHtml = (markdown: string): string => {
  let html = markdown;
  
  // Headers (order matters - check ### before ## before #)
  html = html.replace(/^### (.*$)/gm, '<h3>$1</h3>');
  html = html.replace(/^## (.*$)/gm, '<h2>$1</h2>');
  html = html.replace(/^# (.*$)/gm, '<h1>$1</h1>');
  
  // Bold
  html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  
  // Italic
  html = html.replace(/\*(.*?)\*/g, '<em>$1</em>');
  
  // Inline code
  html = html.replace(/`([^`]+)`/g, '<code>$1</code>');
  
  // Bullet points
  html = html.replace(/^- (.*$)/gm, '<li>$1</li>');
  html = html.replace(/^• (.*$)/gm, '<li>$1</li>');
  html = html.replace(/^\* (.*$)/gm, '<li>$1</li>');
  
  // Numbered lists
  html = html.replace(/^\d+\. (.*$)/gm, '<li>$1</li>');
  
  // Wrap consecutive <li> elements in <ul>
  html = html.replace(/(<li>.*<\/li>\n?)+/g, (match) => `<ul>${match}</ul>`);
  
  // Paragraphs - wrap remaining lines that aren't already HTML
  html = html.split('\n').map(line => {
    if (line.trim() && !line.startsWith('<')) {
      return `<p>${line}</p>`;
    }
    return line;
  }).join('');
  
  return html;
};

/**
 * Check if text content looks like markdown
 */
export const isMarkdownContent = (text: string): boolean => {
  // Check for common markdown patterns
  const markdownPatterns = [
    /^#{1,6}\s/m,           // Headers
    /\*\*.*\*\*/,           // Bold
    /^\s*[-*]\s/m,          // Bullet lists
    /^\s*\d+\.\s/m,         // Numbered lists
    /`[^`]+`/,              // Inline code
    /```[\s\S]*```/,        // Code blocks
    /\[.*\]\(.*\)/,         // Links
  ];
  
  return markdownPatterns.some(pattern => pattern.test(text));
};

/**
 * Check if a filename is a markdown file
 */
export const isMarkdownFile = (filename: string): boolean => {
  const mdExtensions = ['.md', '.markdown', '.mdown', '.mkd', '.mkdn'];
  const lowerName = filename.toLowerCase();
  return mdExtensions.some(ext => lowerName.endsWith(ext));
};
